import * as React from 'react';

type State = string | undefined;

export default function useToggle(
    initialState?: State,
): [State, (item: State) => void] {
    const [activeItem, setActiveItem] = React.useState<State>(initialState);

    function toggleActiveItem(item: State): void {
        if (activeItem === item) {
            setActiveItem(undefined);
        } else {
            setActiveItem(item);
        }
    }

    return [activeItem, toggleActiveItem];
}
